import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// -------------------- Feedback Listing--------------------------//
export const getFeedbackListAPI = async (data) => {
  // const endPoint = `admin/feedback/list`;
  const endPoint =
    `admin/feedback/list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const getFeedbackAPI = async (data) => {
  // const endPoint = `admin/feedback/list`;
  const endPoint =
    `admin/feedback` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const deleteFeedbackApi = async (data) => {
  const endPoint = `admin/feedback` + "?" + new URLSearchParams({ ...data }).toString();;
  return await axios.delete(endPoint, setJwtToken());
};


// ------------------------Add SudAdmin------------------
export const createSubAdminAPI = async (data) => {
  const endPoint = `admin/sub-admin`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ------------------------Edit SubAdmin------------------
export const editSubAdminApi = async (data) => {
  const endPoint = `admin/sub-admin`;
  return await axios.put(endPoint, data, setJwtToken());
};

// -------------------------Change SubAdmin Status------------
export const changeSubAdminStatusApi = async (data) => {
  const endPoint = `sub-admin/change-status`;
  return await axios.put(endPoint, data, setJwtToken());
};

// -------------------------Delete SubAdmin ------------
export const deleteSubAdminApi = async (data) => {
  const endPoint = `sub-admin/delete/${data}`;
  return await axios.delete(endPoint, setJwtToken());
};

// ------------------------Resend Mail------------------
export const resendMailSubAdminApi = async (data) => {
  const endPoint = `sub-admin/resend-email`;
  return await axios.post(endPoint, data, setJwtToken());
};
